<template>
    <div class="page">
        <!-- <img :src="Images.login_bg_img" class="login-bg-img" /> -->
        <!-- <div class="home-btn" @click="toHome">
            <img :src="Images.icon_home" />
        </div> -->
        <div class="logo-box">
            <img :src="Images.icon_logo" class="logo" />
        </div>
        <div class="login-dialog">
            <img :src="Images.icon_logo" class="bg" />
            <div class="tab td-fsc">
                <div class="active">忘记密码</div>
            </div>
            <div class="login-input">
                <img :src="Images.icon_login_phone" />
                <input type="text" v-model="form.mobile" placeholder="请输入手机号">
            </div>
            <div class="login-input">
                <img :src="Images.icon_login_code">
                <div class="input">
                    <input type="text" placeholder="请输入验证码" v-model="form.code">
                </div>
                <div class="code" @click="getCode">{{ time_text ? time_text : "获取验证码" }}</div>
            </div>
            <div class="login-input">
                <img :src="Images.icon_login_password" />
                <div class="input">
                    <input type="password" v-model="form.password" placeholder="请输入新密码">
                </div>
            </div>
            <div class="login-input">
                <img :src="Images.icon_login_password" />
                <div class="input">
                    <input type="password" v-model="form.re_password" placeholder="确认密码">
                </div>
            </div>
            <div class="login-btn">
                <Btn class="btn" loading @confirmEvent="submitForm">立即重置</Btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            time: 60,
            time_text: "",
            timer: null,
            form: {
                mobile: "",
                code: "",
                password: "",
                re_password: "",
            },
        }
    },
    methods: {
        // 倒计时
        setTimeOut() {
            this.timer = setInterval(() => {
                this.time--;
                this.time_text = `${this.time}秒后重试`;
                if (this.time == 0) {
                    clearInterval(this.timer);
                    this.time = 60;
                    this.time_text = "获取验证码";
                }
            }, 1000);
        },
        // 获取验证码
        async getCode() {
            if (this.time !== 60) return;
            let { mobile } = this.form;
            if (!mobile) {
                this.Message({
                    title: "请输入手机号",
                });
                return;
            }
            // if (!this.$checkPhone(mobile)) {
            //     this.Message({
            //         title: "手机号输入有误，请重新输入",
            //     });
            //     return;
            // }
            let url = this.API.smsCode;
            let params = {
                code_type: 2,
                mobile: mobile,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: "短信发送成功，请注意查收！",
                });
                this.setTimeOut();
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 提交
        async submitForm(done) {
           
            let { mobile, code, password, re_password } = this.form;
            if (!mobile) {
                this.Message({
                    title: "请输入手机号",
                });
                return done();
            }
            // if (!this.$checkPhone(mobile)) {
            //     this.Message({
            //         title: "手机号输入有误，请重新输入",
            //     });
            //     return done();
            // }
            if (!code) {
                this.Message({
                    title: "请输入验证码",
                });
                return done();
            }
            if (!password) {
                this.Message({
                    title: "请输入密码",
                });
                return done();
            }
            if (password !== re_password) {
                this.Message({
                    title: "两次密码输入不一致，请重新输入！",
                });
                return done();
            }
            let url = this.API.reset_forget_password;
            let params = {
                mobile: mobile,
                sms_code: code,
                password: password,
                re_password:re_password
            };
            let result = await this.$post(url, params);
            done();
            this.timer && clearInterval(this.timer);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    type: 3,
                    title: "温馨提示",
                    content: "密码修改成功，请使用新密码登录",
                    onClose: ()=>{
                        this.$router.go(-1);
                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.page{
    min-height: 100vh;
    background-color: #fff;
}
.login-bg-img {
    width: 100%;
    height: 339px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
}
.home-btn{
    position: absolute;
    top: 10px;
    left: 10px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 1px 6px 0px rgba(157, 157, 157, 0.2);
    img{
        width: 20px;
        height: 20px;
        object-fit: contain;
    }
}
.other-login {
    display: flex;
    width: 100%;
    justify-content: space-around;
    padding-top: 10px;
    .other-login-item {
        flex: 1;
        img {
            display: block;
            margin: 0 auto;
            width: 30px;
            height: 30px;
        }
        div {
            text-align: center;
            margin-top: 9px;
            font-size: 12px;
            color: #acb6ca;
        }
    }
}
.other-type {
    display: flex;
    justify-content: space-between;
    margin: 55px 20px 27px;
    align-items: center;
    .line {
        flex: 1;
        height: 2px;
        border-top: 1px solid #f0f0f0;
    }
    .text {
        font-size: 14px;
        margin: 0 16px;
        color: #999999;
    }
}
.logo-box{
    padding: 30px 0;
    .logo {
        width: 60px;
        height: 60%;
        display: block;
        margin: 0 auto;
        object-fit: contain;
    }
}
.intro {
    font-size: 20px;
    text-align: center;
    color: #ffffff;
    margin-bottom: 27px;
    margin-top: 20px;
}
.login-dialog {
    background-color: rgba(255,255,255,0.88);
    border-radius: 10px;
    // margin: 0 10px;
    // box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
    padding-bottom: 40px;
    position: relative;
    z-index: 2;
    .bg{
        position: absolute;
        top: 6%;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
        opacity: 0.08;
        width: 260px;
        height: 260px;
        object-fit: contain;
    }
    .tab {
        padding: 0 10px;
        font-size: 14px;
        counter-reset: #333;
        >div{
            min-width: 90px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.2s;
            &.active{
                font-size: 16px;
                font-weight: 500;
                color: #7181eb;
            }
        }
    }
    .login-input {
        margin: 10px 15px;
        height: 40px;
        padding: 0 5px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-bottom: solid #eee 1px;
        .input{
            height: 40px;
            flex: 1;
        }
        input {
            width: 100%;
            font-size: 14px;
            color: #999999;
            line-height: 40px;
        }
        img {
            width: 16px;
            height: 20px;
            margin-right: 15px;
            display: block;
            object-fit: contain;
        }
        .code {
            margin-left: 10px;
            padding-left: 10px;
            font-size: 13px;
            height: 15px;
            color: #7181eb;
            display: flex;
            justify-content: center;
            align-items: center;
            border-left: solid #7181eb 1px;
        }
    }
    .login-type {
        margin: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .line{
            height: 14px;
            width: 1px;
            background-color: #eee;
            margin: 0 10px;
        }
        a {
            text-decoration: none;
            outline: 0;
            font-size: 13px;
            color: #999999;
        }
    }
    .login-btn {
        margin: 40px 15px 10px;
        .btn{
            display: flex;
            width: 100%;
            height: 40px;
            background: linear-gradient(225deg,#9cb2f4, #6472e8);
            border-radius: 3px;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
        }
    }
}
</style>